import { render } from "./ConfigValidation.vue?vue&type=template&id=457cf84c&scoped=true"
import script from "./ConfigValidation.vue?vue&type=script&lang=js"
export * from "./ConfigValidation.vue?vue&type=script&lang=js"

import "./ConfigValidation.vue?vue&type=style&index=0&id=457cf84c&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457cf84c"]])

export default __exports__